export default __webpack_public_path__ + "cassette.png";